import { AppointmentCard } from "./AppointmentCard";

type AppointmentListProps = {
  title: string;
  appointments: {
    id: string;
    doctor_name?: string;
    location?: string;
    date: string;
    notes?: string;
    service?: {
      service_name?: string;
    };
    status?: string;
  }[];
  isPast?: boolean;
};

export const AppointmentList = ({ title, appointments = [], isPast = false }: AppointmentListProps) => {
  if (!Array.isArray(appointments)) {
    console.error("Appointments prop is not an array:", appointments);
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold">{title}</h2>
      {appointments.length === 0 ? (
        <p className="text-muted-foreground text-center py-4">
          Aucun rendez-vous trouvé
        </p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {appointments.map((appointment) => (
            <AppointmentCard 
              key={appointment.id} 
              appointment={appointment}
              isPast={isPast}
            />
          ))}
        </div>
      )}
    </div>
  );
};